<template>
    <div>
        <content-header v-bind:title="$t(ftitle)"></content-header>
        <div class="w3-container flow-main-content w3-animate-opacity">

            <!--ACTIVE ROOMS -->
            <active-rooms v-if="isNormal && physiciansLoaded" :physicians="physicians"></active-rooms>

            <div class="w3-container zero tabs-container">
                <div class="w3-row cursor-pointer w3-center flow-margin-top w3-margin-bottom flow-padding-top flow-padding-bottom tabs-container-head">
                    <div class="w3-show-inline-block w3-margin-right"
                         @click="currentTabIndex = 0"
                         v-bind:class="currentTabIndex === 0 ? 'active' : 'inactive'">
                        <i class="fa fa-user-md w3-large flow-margin-right"></i>
                        <span class="flow-margin-left">{{$t("consultationRooms")}}</span>
                    </div>
                    <span class="divider">|</span>
                    <div class="w3-show-inline-block w3-margin-right w3-margin-left"
                         @click="currentTabIndex = 1"
                         v-bind:class="currentTabIndex === 1 ? 'active' : 'inactive'">
                        <i class="fa fa-x-ray w3-large flow-margin-right"></i>
                        <span class="flow-margin-left">{{$t("examinationRooms")}}</span>
                    </div>
                </div>

                <div class="w3-row flow-margin-top flow-padding-top  flow-card blue-top w3-animate-opacity" >
                    <div class="zero-left flow-padding-top flow-form-inline-input w-100pc">

                        <!--CONSULTATION ROOMS -->
                        <div  v-show="currentTabIndex === 0"
                             class="w3-container w3-animate-opacity">
                            <consultation-rooms v-if="physiciansLoaded" :physicians="physicians"></consultation-rooms>
                        </div>

                        <!--SHARED ROOMS -->
                        <div v-show="currentTabIndex === 1"
                             class="w3-container w3-animate-opacity">
                            <shared-rooms></shared-rooms>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import Vue from 'vue';
import ContentHeader from "../components/common/ContentHeader";
import ActiveRooms from "../components/room/ActiveRooms";
import ConsultationRooms from "../components/room/ConsultationRooms";
import SharedRooms from "../components/room/SharedRooms";

let frc = Vue.prototype.$frc;

    export default {
        name: "Rooms",
        components: {ContentHeader, ActiveRooms, ConsultationRooms, SharedRooms},
        props: ['ftitle'],
        data: function() {
            return {
                currentTabIndex: 0,
                physicians: [],
                physiciansLoaded: false
            }
        },
        beforeMount() {
          const app = this;
          if (this.isNormal) {
            if (!Vue.prototype.$currentUser.user.physicians) {
              Vue.notifyError({
                title: this.$t("NO_PHYSICIAN_LINKED")
              });
            }
            let userPhysicians = Vue.prototype.$currentUser.user.physicians;
            let noOfPhysiciansToLoad = userPhysicians.length;
            for (let index in userPhysicians) {
              frc.getPhysicianWithId(userPhysicians[index]).then(function (res) {
                app.physicians.push(res.data);
              }).catch(function (ex) {
                console.log(ex);
              }).finally(function () {
                app.physiciansLoaded = --noOfPhysiciansToLoad === 0;
              });
            }
          } else {
            frc.getPhysiciansInWard(Vue.prototype.$currentWard.id).then(function (res) {
              app.physicians = res.data;
              Vue.sortByKey(app.physicians, 'name');
            }).finally(function () {
              app.physiciansLoaded = true;
            });
          }
        },
      computed: {
            isNormal (){
                return Vue.isNormal(Vue.prototype.$currentUser.user.role);
            },
        },
    }

</script>

<style scoped>

</style>